import { createFileRoute } from "@tanstack/react-router";
import { GhlSyncTab } from "@/components/admin/GhlSyncTab";

export const Route = createFileRoute("/admin/ghl-sync")({
  head: () => ({
    meta: [
      { title: "CRM Sync · Admin · INFLOW Marketing" },
      { name: "description", content: "Audit every lead sync to the CRM: status, contact id, and errors." },
      { name: "robots", content: "noindex,nofollow" },
    ],
  }),
  component: () => (
    <div className="space-y-6">
      <div>
        <h1 className="font-serif text-3xl tracking-tight">GoHighLevel Sync</h1>
        <p className="text-sm text-muted-foreground mt-1">
          Last sync status, contact ID, and error details for every lead submission.
        </p>
      </div>
      <GhlSyncTab />
    </div>
  ),
});
